import { Button, Collapse } from 'react-bootstrap';
import { useAccordionContext } from '../contexts/AccordionContext';
import { CollapseProperties, GenericNode } from '../data/LockerDataTypes';
import { classNames } from '../services/lockerService';
import { ChevronDown, ChevronUp } from './Miscellaneous';

const CollapseComponent = (node: GenericNode<CollapseProperties>) => {
    const { accordionExpanded, setAccordionExpanded } = useAccordionContext();

    const CollapseSelector = () => {
        setAccordionExpanded(!accordionExpanded);
    }

    const GetAccordionHeaderText = () => {
        return accordionExpanded ? node.properties.textShowButton : node.properties.textHideButton;
    }

    const GetAccordionArrow = (): any => {
        if (accordionExpanded) {
            return <ChevronUp />;
        }
        return <ChevronDown />;
    }

    return (
        <>
            <div className="d-md-none">
                <Collapse in={accordionExpanded}>
                    <div id={node.properties.componentId}>
                        {node.children}
                    </div>
                </Collapse>

                <Button variant="outline-primary" size="sm"
                    className={classNames(accordionExpanded ? 'show' : '', "w-100 text-nowrap rounded locker-plugin-show-hide-collapse-button")}
                    onClick={CollapseSelector} aria-controls={node.properties.componentId} aria-expanded={accordionExpanded}>
                    {GetAccordionArrow()}{GetAccordionHeaderText()}
                </Button>
            </div>

            <div className={"rounded d-none d-md-block"}>
                {node.children}
            </div>
        </>
    )
}

export default CollapseComponent;

